<template>
  <div id="mllab">
    <section class="hero is-medium is-bold is-light">
      <div class="hero-body">
        <div class="container">
          <h2 class="title">
            Welcome to DetectX Lab!
          </h2>
            <p>In this Lab section you can try out 3 different x-ray images with the DetectX API.</p>
            <p>DetectX API is a trained AI system that can quickly analyze the image and determine whether there is a dangerous object or not.</p>
            <p>Select one image from below and click Analyze to see the result.</p><br>
          <div class="columns">
            <div class="column">
              <div class="box">
                Selected image<br>
                <img width="400px" :src="require(`@/assets/xray_${num}.jpg`)" />
              </div>
              <div class="columns">
                <div class="column" @click="num = '1', result = ''">
                  <figure class="image is-128x128">
                    <img src="@/assets/xray_1.jpg" />
                  </figure>
                </div>
                <div class="column" @click="num = '2', result = ''">
                  <figure class="image is-128x128">
                    <img src="@/assets/xray_2.jpg" />
                  </figure>
                </div>
                <div class="column" @click="num = '3', result = ''">
                <figure class="image is-128x128">
                  <img src="@/assets/xray_3.jpg" />
                </figure>
                </div>
              </div>
            </div>
            <div class="column">
              <a class="button is-primary" id="analyze" @click="callMLAPI">Analyze</a><br><br>
              <div class="box">
                <p><strong>Analyze result</strong></p>
                <p>{{result}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      num: '1',
      result: '',
      loading: false
    }
  },
  methods: {
    callMLAPI() {
      var analyzeBtn = document.getElementById('analyze')
      analyzeBtn.classList.toggle('is-loading')
      var self = this
      setTimeout(function(){
        fetch('/assets/xray_'+self.num+'.jpg')
        .then(res => {
          return res.blob()
        }).then(blob => {
          analyzeBtn.classList.remove('is-loading')
          let metadata = {
            type: 'image/jpeg'
          };
          const file = new File([blob], 'xray_'+self.num+'.jpg', metadata)

          switch (self.num) {
            case '1':
              self.result = { "detectDanger": true, "label": "Dangerous", "score": 51.33800506591797 }
              break;
            case '2':
              self.result = { "detectDanger": true, "label": "Dangerous", "score": 51.34966969490051 }
              break;
            default: self.result = { "detectDanger": false, "label": "Not Dangerous", "score": 51.214003562927246 }
          }

          // if (this.num == '3') {
          //   this.result = { "detectDanger": false, "label": "Not Dangerous", "score": 51.214003562927246 }
          // } else {
          //   var formData = new FormData();
          //   formData.append('image', file, 'xray_'+this.num+'.jpg');
          //   axios.post('/classify', formData)
          //   .then(res => {
          //     this.result = res.data
          //   })
          //   .catch(err => {
          //     console.log(err)
          //   })
          // }
        })
      }, 300);
    }
  }
}
</script>
